import React from "react";
import { Autocomplete } from "@/components/atoms/index";
import { useFilterCompanies, useFilterJobs } from "@/providers/contexts";
import {
  AutocompleteProps,
  AutocompleteOption,
} from "@/components/atoms/Autocomplete";
import { useCompanyFilterOptions, useJobPostFilterOptions } from "@/hooks";
import { FilterPanelProps } from "../FilterPanel";
import { HealthcareDomain } from "@/types/core";

interface DomainFilterProps {
  componentName: string;
  boxSx?: AutocompleteProps["boxSx"];
  autocompleteSx?: AutocompleteProps["autocompleteSx"];
  page: FilterPanelProps["page"];
}

export const DomainFilter = ({
  componentName,
  boxSx,
  autocompleteSx,
  page,
}: DomainFilterProps) => {
  const { filters: jobPostFilters } = useJobPostFilterOptions();
  const { healthcareDomains: companyDomains } = useCompanyFilterOptions();

  const {
    filters: jobFilters,
    dispatch: jobDispatch,
    loading: jobLoading,
  } = useFilterJobs();
  const {
    filters: companyFilters,
    dispatch: companyDispatch,
    loading: companyLoading,
  } = useFilterCompanies();

  const isSearchPage = page === "search";
  const domains = isSearchPage
    ? jobPostFilters?.healthcareDomains || []
    : companyDomains;

  const { selectedHealthcareDomains } = isSearchPage
    ? jobFilters
    : companyFilters;

  const dispatch = isSearchPage ? jobDispatch : companyDispatch;
  const loading = jobLoading || companyLoading;

  const options = domains.map(domain => ({
    key: domain.id,
    value: domain.value,
  }));

  const selectedOptions = selectedHealthcareDomains.map(selected => {
    const domain = domains.find(domain => domain.value === selected.value);

    return {
      key: domain?.id ?? "",
      value: domain?.value ?? "",
    };
  });

  return (
    <Autocomplete
      multiple
      boxSx={boxSx}
      autocompleteSx={autocompleteSx}
      componentName={componentName + "-domain-filter"}
      inputLabel="Healthcare Domains"
      options={options}
      value={selectedOptions}
      onChange={(_: React.SyntheticEvent<Element, Event>, value: any) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = selectedValues
          .map(opt => domains.find(domain => domain.id === opt.key))
          .filter((domain): domain is Pick<HealthcareDomain, "id" | "value"> =>
            Boolean(domain),
          );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedHealthcareDomains: selected },
        });
      }}
      loading={loading}
    />
  );
};
